var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1096 12.0152C17.2004 12.0152 18.2464 11.5819 19.0177 10.8106C19.7889 10.0394 20.2222 8.99333 20.2222 7.90261C20.2222 6.81189 19.7889 5.76584 19.0177 4.99458C18.2464 4.22333 17.2004 3.79004 16.1096 3.79004C15.0189 3.79004 13.9729 4.22333 13.2016 4.99458C12.4304 5.76584 11.9971 6.81189 11.9971 7.90261C11.9971 8.99333 12.4304 10.0394 13.2016 10.8106C13.9729 11.5819 15.0189 12.0152 16.1096 12.0152Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1094 12.0153C17.0716 12.0157 18.0035 11.6787 18.7429 11.063C19.4824 10.4472 19.9824 9.59162 20.1561 8.64519C20.3299 7.69875 20.1662 6.72137 19.6937 5.88315C19.2211 5.04493 18.4696 4.39894 17.5699 4.05762",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18859 11.1994C10.3707 11.1994 11.5044 10.7299 12.3403 9.89397C13.1761 9.0581 13.6457 7.92441 13.6457 6.7423C13.6457 5.56019 13.1761 4.4265 12.3403 3.59062C11.5044 2.75475 10.3707 2.28516 9.18859 2.28516C8.00648 2.28516 6.87279 2.75475 6.03691 3.59062C5.20104 4.4265 4.73145 5.56019 4.73145 6.7423C4.73145 7.92441 5.20104 9.0581 6.03691 9.89397C6.87279 10.7299 8.00648 11.1994 9.18859 11.1994Z",
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0187 17.4637C18.1993 18.9157 16.7267 21.7151 14.1056 21.7151H4.26902C1.64959 21.7151 0.177018 18.9157 2.35759 17.4637C4.38042 16.1152 6.75795 15.3975 9.18902 15.4014C11.7142 15.4014 14.0627 16.1608 16.0187 17.4637Z",
    stroke: "#828282",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.152 21.7148C14.1366 21.715 14.1211 21.7151 14.1056 21.7151H4.26902C1.64959 21.7151 0.177018 18.9157 2.35759 17.4637C4.38042 16.1152 6.75795 15.3975 9.18902 15.4014C10.6194 15.4014 11.9931 15.6451 13.2708 16.0931C13.9776 15.9573 14.699 15.8886 15.4255 15.8897C17.7569 15.8897 19.9221 16.5908 21.7272 17.7925C23.7381 19.1314 22.3787 21.7148 19.9615 21.7148H14.152Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7266 21.7168H19.9631C22.3803 21.7168 23.738 19.1316 21.7271 17.7911C21.1681 17.4195 20.5772 17.0982 19.9614 16.8311",
    stroke: "#828282",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUserIcon);
export default __webpack_public_path__ + "static/media/multiple-user-icon.437294b023a43fd7ccf97177e49e638e.svg";
export { ForwardRef as ReactComponent };